import Cookies from "js-cookie";
import axios from "axios";
import { getBaseUrl } from "../../utils";

const getmember = getBaseUrl() + "admin/subadmins";
const status_updateTestimonial = getBaseUrl() + "admin/updateTestimonial";
const deleteMember = getBaseUrl() + "admin/subadmin";
const addMember = getBaseUrl() + "admin/subadmin";
const updateTestimonial = getBaseUrl() + "admin/updateTestimonial";

export const updateTestimonial_api = async (data) => {
  let config = {
    method: "patch",
    url: updateTestimonial,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const addMember_api = async (data) => {
  let config = {
    method: "post",
    url: addMember,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const deleteMemeber_api = async (data) => {
  let config = {
    method: "delete",
    url: deleteMember + `/${data.id}`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    // data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const status_updateTestimonial_api = async (data) => {
  let config = {
    method: "patch",
    url: status_updateTestimonial,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const getmembers_api = async (data) => {
  let config = {
    method: "get",
    url:
      getmember +
      `?page=${data.page || ""}&limit=${data.limit || ""}&search=${
        data.search || ""
      }`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
